import { render, staticRenderFns } from "./cxDropdown.vue?vue&type=template&id=338d37fc"
import script from "./cxDropdown.vue?vue&type=script&lang=js"
export * from "./cxDropdown.vue?vue&type=script&lang=js"
import "./cxDropdown.vue?vue&type=style&index=0&id=338d37fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports